import { Component } from '@angular/core';

@Component({
  selector: 'app-siteunder',
  templateUrl: './siteunder.component.html',
  styleUrls: ['./siteunder.component.css']
})
export class SiteunderComponent {

}
